<div class="right-margin">
    <button class="close-icon" (click)="dialogRef.close(false)"><div class="line1"><div class="line2"></div></div></button>
</div>
<div class="wrapperMain">
    <div class="body form">
        <h2>Manager Contact</h2>
        <div class="mt-10 mb-10">
            <div class="table-view">
                <div class="row">
                    <div class="cell">
                        <input type="text" name="FirstName" [class]="getClassesForInput('FirstName', true, editContact.firstName)" (input)="resetError('FirstName')" placeholder="First name" [(ngModel)]="editContact.firstName" [minlength]="validationService.getMinLength('User', 'firstName')" [maxlength]="validationService.getMaxLength('User', 'firstName')" />
                        @if (getVisibilityForLabel(editContact.firstName)) {
                        <div class="placeholder">First name</div>
                        }
                    </div>
                    <div class="cell">
                        <input type="text" name="LastName" [class]="getClassesForInput('LastName', true, editContact.lastName)" (input)="resetError('LastName')" placeholder="Last name" [(ngModel)]="editContact.lastName" [minlength]="validationService.getMinLength('User', 'lastName')" [maxlength]="validationService.getMaxLength('User', 'lastName')" />
                        @if (getVisibilityForLabel(editContact.lastName)) {
                        <div class="placeholder">Last name</div>
                        }
                    </div>
                </div>
            </div>
            <input type="text" name="Email" class="w-100" [class]="getClassesForInput('Email', true, editContact.email)" (input)="resetError('Email')" [(ngModel)]="editContact.email" placeholder="Email" />
            @if (getVisibilityForLabel(editContact.email)) {
            <div class="placeholder">Email</div>
            }
            <input type="text" name="Phone"
                   [class]="getClassesForInput('Phone', true, (((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'1':'')))"
                   (input)="resetError('Phone')"
                   placeholder="Mobile Phone"
                   [dropSpecialCharacters]="false"
                   [formControl]="currentPhoneNumber"
                   (focus)="focusField('Phone')"
                   mask="(000) 000-0000"
                   [showMaskTyped]="(focusedField()=='Phone')||(currentPhoneNumber.value!=null && currentPhoneNumber.value?.trim()!='' && !currentPhoneNumber.value.valid)" />
            @if (getVisibilityForLabel(((currentPhoneNumber.value==null)?'':currentPhoneNumber.value?.trim())+((focusedField()=='Phone')?'phone':''))) {
            <div class="placeholder">Mobile Phone</div>
            }
            @if (errorY().showError()) {
            <div class="error-block">{{errorY().error}}</div>
            }
            <div class="block-buttons full-width mb-20 under-card">
                <button type="button" (click)="closeDialog()">Cancel</button>
                <button type="button" class="highlighted-button" (click)="confirm()">Confirm</button>
            </div>

        </div>
    </div>
</div>